import { TopicV4DTO } from '@west-australian-newspapers/publication-types'
import { LocationState } from '../data'

export const getIsFoulPlayGeoLocationBlocked = (
    geoLocation: LocationState,
    primaryTopic: string,
    secondaryTopic?: TopicV4DTO[],
) => {
    const isGeoLocationBlocked =
        (geoLocation.userSelectedRegion === 'NSW' &&
            geoLocation.countryCode === 'AU') ||
        (geoLocation.countryCode === 'AU' && geoLocation.region === 'NSW')

    const isGeoBlockedTopic =
        primaryTopic === 'features/foul-play' ||
        (secondaryTopic &&
            secondaryTopic.findIndex(
                (topic) => topic.id === 'features/foul-play',
            ) !== -1)

    return isGeoBlockedTopic && isGeoLocationBlocked
}
